<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    tabindex="-1"
    id="offcanvasSettingBranchInventory"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <div class="bg-top-nav border offcanvas-header py-2">
      {{ $t('Setting Branches') }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>
    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div
        class="bg-white border-bottom mb-3 px-3 py-2 sticky-top"
      >
        <div class="d-flex">
          <div class="row g-3 py-2">
            <b style="font-size: 18px;" class="mt-2">
              {{ data.name }}
            </b>
          </div>
        </div>
      </div>

      <div class="px-3 pb-3">
        <p class="text-muted small mb-2">
          <i class="fa-solid fa-circle-info me-1"/>
          {{ $t('Manage inventory settings for each branch.') }}
        </p>

        <div>
          <template
            v-for="(branch, branchIndex) in form.setting_branches"
          >
            <item-setting-branch-form
              :index="branchIndex"
              :branch="branch"
            />
          </template>
        </div>
      </div>
    </div>

    <div class="bg-white border-top justify-content-center modal-footer py-2" v-if="!loading">
      <ladda
        text="Save"
        :btn-class="'btn btn-theme btn-block me-2'"
        :loading="loadingSave"
        :disabled="v$.$invalid"
        @click="handleSave"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-setting-branch";
import Ladda from '@/plugins/Ladda.vue';
import { Inventories } from '@/services/endpoint/inventories.service';
import ItemSettingBranchForm from './ItemSettingBranchForm.vue';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.form);
  },
  props: {
    inventoryId: {
      type: Number,
      required: true
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    Ladda,
    ItemSettingBranchForm
  },
  data() {
    return {
      loading: true,
      loadingSave: false,
      hasPermission: false,
      form: {
        setting_branches: []
      },
      data: {}
    }
  },
  methods: {
    formatSettingBranchData(rawData) {
      if (!rawData || !rawData.setting_branches) return { setting_branches: [] };

      return {
        setting_branches: rawData.setting_branches.map(b => ({
          id: b.id,
          branch_id: b.branch_id,
          name: b.name,
          code: b.code,
          is_in_stock: b.is_in_stock
        }))
      };
    },
    async fetchData() {
      this.loading = true;
      await Inventories.getSettingBranch(this.inventoryId).then(res => {
        this.data = res.data.data;
        this.form = this.formatSettingBranchData(res.data.data);
        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
        }
        this.loading = false;
        // throw err;
      });
    },
    setParamsBeforeSendSave() {
      const setting_branches = this.form.setting_branches.map(b => ({
        id: b.id,
        is_in_stock: b.is_in_stock
      }));

      return { setting_branches };
    },
    async handleSave() {
      this.loadingSave = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }

      await Inventories.updateSettingBranch(this.inventoryId, this.setParamsBeforeSendSave()).then(res => {
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        this.loadingSave = false;
      });
    },
  },
  mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas', () => {
      this.fetchData();
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$emit('close');
    });
  }
}
</script>
